import Vue from 'vue'
import VueI18n from 'vue-i18n'
//import sharedMessages from './locales/en_US'
//@TODO implement dynamic globalmessages load

Vue.use(VueI18n)

export const DEFAULT_LOCALE = 'en_US'

export const i18n = new VueI18n({
  locale: window.wcs_config ? window.wcs_config.locale : DEFAULT_LOCALE, // set locale from WCS config
  fallbackLocale: DEFAULT_LOCALE,
  missing: (locale, key) => {
    return ''
  },
  //sharedMessages: sharedMessages,
})

const loadedSections = ['global'] // global labels shared between all components
const _pendingPromises = {}

/**
 * This function loads the translations to be used in the specified component
 * @param {string} section the section name, that should correspond to the
 * section sub-directory in the locale folder ex: 'store-locator'
 */
export async function loadSectionTranslations(section) {
  const selectedLocale = i18n.locale
  // If the language was already loaded
  if (loadedSections.includes(section)) {
    return
  }

  if (_pendingPromises[section]) return _pendingPromises[section]

  _pendingPromises[section] = (async () => {
    // If the section language hasn't been loaded yet
    try {
      const messages = await import(/* webpackChunkName: "lang-[request]" */ `./locales/${section}/${selectedLocale}.js`)

      if (messages) i18n.mergeLocaleMessage(selectedLocale, messages.default)

      if (selectedLocale !== DEFAULT_LOCALE) {
        // load also default locale for fallback
        const defaultLocaleMessages = await import(/* webpackChunkName: "lang-[request]" */ `./locales/${section}/en_US.js`)
        i18n.mergeLocaleMessage(DEFAULT_LOCALE, defaultLocaleMessages.default)
      }
      loadedSections.push(section)
    } catch (error) {
      console.warn(`[i18n] Failed to load translations for section "${section}":`, error)
        // load also default locale for fallback
      try {
        const defaultLocaleMessages = await import(/* webpackChunkName: "lang-[request]" */ `./locales/${section}/en_US.js`)
        i18n.mergeLocaleMessage(DEFAULT_LOCALE, defaultLocaleMessages.default)
      } catch(fallbackError) {
        console.error(`[i18n] Failed to load fallback translations for section "${section}":`, fallbackError)
      }
    } finally {
      delete _pendingPromises[section]
    }
  })()
  
  return _pendingPromises[section]
}

export default i18n
